import React, { useEffect, useState, useContext } from 'react';

import FilteringTable from './Table/FilteringTable/FilteringTable';
import ColumnFilter from './Table/FilteringTable/ColumnFilter';
import PageTitle from '../layouts/PageTitle';

import { tableColumnNamesRefereeAdmin } from '../../utils/tableColumnNamesRefereeAdmin';
import { arrayToFlatObject } from '../../utils/arrayToFlatObject';

import { tableRowsValuesRefereeAdministration } from '../../utils/tableRowsValuesRefereeAdministration';
import { CommonCollections } from '../../App';
import SecretaryRefereeReportCell from './SecretaryRefereeReportCell';
import { filteringTableGetTableColumns } from '../../utils/filteringTableGetTableColumns';
import { useStaticCollections } from '../../context/StaticCollections';
import { useAdminCollections } from '../../context/AdminCollections';
import { useRefereeCollections } from '../../context/RefereeReportCollections';
import { getReportRoundYear } from '../../utils/getReportRoundYear';
import { CM_PRIMARY_ID, NOMINATION_STATUS } from '../../utils/constants';

const SecretaryRefereeReport = () => {
  const {
    fellows,
    declineReasons,
    nonAasReferees,
    nominationStatusTypes,
    refereeStatuses,
    sectionalCommitteesWithCmse,
    users,
    isLoading: staticLoading,
  } = useStaticCollections();

  const {
    candidates,
    nominationArray,
    isLoading: adminLoading,
  } = useAdminCollections();

  const { setRefereeReportId } = useContext(CommonCollections);

  const { refereeReports, isLoading: refereeLoading } = useRefereeCollections();

  const [refereesData, setRefereesData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);

  useEffect(() => {
    const tableColumns = filteringTableGetTableColumns(
      tableColumnNamesRefereeAdmin,
      ColumnFilter,
      SecretaryRefereeReportCell,
    );
    const tableData = tableRowsValuesRefereeAdministration(
      refereeReports,
      refereeStatuses,
      declineReasons,
    );

    setTableColumn(tableColumns);
    const refereeData = [tableData.map((item) => item.nominationId), tableData];

    const nominationArr = nominationArray.map((item) => ({
      [item.id]: item.attributes,
    }));

    const nominationsObj = arrayToFlatObject(nominationArr);

    const tableDataTwo = Object.values(refereeData[1]).map((referee) => {
      if (nominationsObj[referee.nominationId] !== undefined) {
        referee.candidate =
          candidates[nominationsObj[referee.nominationId].candidateId];
        referee.sectionalCommittee =
          sectionalCommitteesWithCmse[
            nominationsObj[referee.nominationId]?.sectionalCommitteeId ??
              CM_PRIMARY_ID
          ];
        referee.nominationStatus =
          nominationStatusTypes[
            nominationsObj[referee.nominationId].nominationStatusTypeId
          ];
        referee.nominationStatusTypeId =
          nominationsObj[referee.nominationId].nominationStatusTypeId;
      }
      referee.refereeUser = referee.refereeFellowId
        ? fellows[referee.refereeFellowId]
        : nonAasReferees[referee.nonAasRefereeId];
      referee.reportFile = referee.report.data
        ? referee.report.data.attributes.url
        : null;
      referee.reportUploadedYear = getReportRoundYear(referee);
      return referee;
    });
    const filteredRefereeReport = tableDataTwo
      .filter(
        (item) =>
          (item.nominationStatusTypeId === NOMINATION_STATUS.SUBMITTED ||
            item.nominationStatusTypeId === NOMINATION_STATUS.SHORTLISTED) &&
          item.independentAssessor === 'Referee' &&
          item.refereeArchived === false,
      )
      .sort((a, b) => a.candidate.localeCompare(b.candidate));
    setRefereesData(filteredRefereeReport);
    setRefereeReportId(null);
  }, [
    refereeStatuses,
    sectionalCommitteesWithCmse,
    users,
    declineReasons,
    fellows,
    candidates,
    nonAasReferees,
    nominationArray,
    refereeReports,
    setRefereeReportId,
    nominationStatusTypes,
  ]);

  return (
    <>
      <PageTitle activeMenu="Referee Report Secretaries" motherMenu="Home" />
      <FilteringTable
        componentName="AdminRefereeReport"
        columns={tableColumn}
        data={refereesData}
        isLoading={staticLoading || adminLoading || refereeLoading}
      />
    </>
  );
};

export default SecretaryRefereeReport;
